var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:[
        'ui-button',
        `--${_setup.props.colorScheme}`,
        `--${_setup.props.size}`,
        _setup.props.disabled && `--disabled`,
        _setup.props.noShadow && `--no-shadow`,
    ],on:{"click":function($event){$event.stopPropagation();return _setup.handleClick.apply(null, arguments)}}},[(_vm.loading)?[_c('ui-icon',[_c('ui-icon-loading')],1)]:(_vm.$slots.icon)?_vm._t("icon"):(_setup.props.icon)?_c('ui-icon',[_c(_setup.props.icon,{tag:"component"})],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }